import React from "react";
import styled from "styled-components";
import Tag from "../../../tagSelect/tag";

const PromotionTag: React.FC<{
    promotionTagType: string;
}> = ({ promotionTagType }) => {
    return <StyledTag disableRemove tagKey={promotionTagType || "-"} />;
};

const StyledTag = styled(Tag)`
    background-color: ${(props) => props.theme.colors.primary[400]};
    color: ${(props) => props.theme.colors.accent1[700]};
    font-weight: ${(props) => props.theme.fontWeight.bold};
    margin: 0 auto;
    min-width: 4rem;
    display: grid;
    place-items: center;
`;

export default PromotionTag;
